require('dotenv').config()

const Thmesev ="v89" 

export default Thmesev;
